import { API_URL } from "../../global/components/Constants";
import { parseMarginPadding, continueBtn, parseResult } from '../controlUtils';

export function displayCardUtil(obj, entryPoint){

    const content = JSON.parse(obj.Content);
    const display = content.Display;
    const theme = content.Theme;
    const size = content.Size;

    let sizeParams = {
        name: size,
        title: 0,
        desc: 0,
        zoom: 0
    }

    if(size == "small"){
        sizeParams.title = 18;
        sizeParams.desc = 15;
    }
    else if(size == "medium"){
        sizeParams.title = 22;
        sizeParams.desc = 15;
    }
    else if(size == "large"){
        sizeParams.title = 26;
        sizeParams.desc = 16;
    }

    if(entryPoint == "presentation" && obj.Presentation != ""){
        const ptn = JSON.parse(obj.Presentation);
        if(ptn.TitleSize != "") { sizeParams.title = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { sizeParams.desc = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { sizeParams.zoom = parseInt(ptn.Zoom) }
    }

    if(entryPoint == "editor"){
        sizeParams.zoom = 60;
    }

    let card = <></>;

    if(display == "default"){
        card = defaultCard(content, obj.Photo, sizeParams);
    }
    else if(display == "expand"){
        card = expandCard(content, obj.Photo, sizeParams);
    }
    else if(display == "compact"){
        card = compactCard(content, obj.Photo, sizeParams);
    }

    return parseResult(card, obj, entryPoint);
}

function defaultCard(content, photo, size){

    const theme = content.Theme;
    const title = content.Title;
    const desc = content.Description;
    const marginPadding = content.MarginPadding;

    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    const styles = {
        card: {
            background: bgColor,
            flex: 1,
            minWidth: 200,
            maxWidth: 500,
            zoom: `${size.zoom}%`,
            borderRadius: 10,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
        },
        photo:{
            wrap:{
                position: 'relative',
            },
            holder:{
                background: '#e5ecee', 
                height: 150, 
                width: 'auto', 
                borderRadius: 5, 
                marginBottom: 10
            },
            img: {
                width: '100%',
                borderRadius: 5,
                marginBottom: 10
            }
        },
        title:{
            color: txtColor,
            fontSize: size.title
        },
        desc:{
            color: txtColor,
            fontSize: size.desc
        }
    }

    return (
        <div style={styles.card}>
            <div style={styles.photo.wrap}>
                {displayImage(photo, styles.photo)}
            </div>
            <h4 style={styles.title}>{title}</h4>
            <div style={styles.desc}>{desc}</div>
        </div>
    )
}

function expandCard(content, photo, size){

    const theme = content.Theme;
    const title = content.Title;
    const desc = content.Description;
    const marginPadding = content.MarginPadding;

    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    const styles = {
        card: {
            background: bgColor,
            flex: 1,
            minWidth: 200,
            maxWidth: 500,
            borderRadius: 10,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            zoom: `${size.zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
        },
        photo:{
            wrap:{
                position: 'relative'
            },
            holder:{
                background: '#e5ecee', 
                height: 150, 
                width: 'auto', 
                borderRadius: 5, 
                marginBottom: 10
            },
            img: {
                width: '100%',
                borderRadius: 5,
                marginBottom: 10
            }
        },
        title:{
            color: txtColor,
            fontSize: size.title,
            marginBottom: 10
        },
        desc:{
            color: txtColor,
            fontSize: size.desc
        }
    }

    return (
        <div style={styles.card}>
            <h4 style={styles.title}>{title}</h4>
            <div style={styles.photo.wrap}>
                {displayImage(photo, styles.photo)}
            </div>
            <div style={styles.desc}>{desc}</div>
        </div>
    )
}

function compactCard(content, photo, size){

    const theme = content.Theme;
    const title = content.Title;
    const desc = content.Description;
    const marginPadding = content.MarginPadding;

    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    const styles = {
        card: {
            background: bgColor,
            flex: 1,
            minWidth: 200,
            maxWidth: 500,
            borderRadius: 10,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            zoom: `${size.zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
        },
        body:{
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
        },
        photo:{
            holder:{
                background: '#e5ecee', 
                height: 150, 
                width: 'auto', 
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10, 
                marginBottom: 5
            },
            img: {
                width: '100%',
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                marginBottom: 5
            }
            
        },
        title:{
            color: txtColor,
            fontSize: size.title,
            marginBottom: 10
        },
        desc:{
            color: txtColor,
            fontSize: size.desc
        }
    }

    return (
        <div style={styles.card}>
            {displayImage(photo, styles.photo)}
            <div style={styles.body}>
                <h4 style={styles.title}>{title}</h4>
                <div style={styles.desc}>{desc}</div>
            </div>
        </div>
    )
}

function displayImage(photo, styles){

    if(photo == ""){
        return <div style={styles.holder}></div>
    }
    else if(photo.length > 200){
        return <img  src = {photo} className={"photo"}  style={styles.img} />
    }
    else{
        const src = `${API_URL}/uploads/topic/component/${photo}`;
        return <img  src = {src} className={"photo"}  style={styles.img} />
    }
}